import { render, staticRenderFns } from "./routePosList.vue?vue&type=template&id=a3852ce4"
import script from "./routePosList.vue?vue&type=script&lang=js"
export * from "./routePosList.vue?vue&type=script&lang=js"
import style0 from "./routePosList.vue?vue&type=style&index=0&id=a3852ce4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports